import { useEffect } from 'react'
import { trackWebVisit } from '../../utils/webVisits'
import { useLocation } from 'react-router-dom'
import { isPublicMarketingPath, trackMetaPageView } from '../../utils/metaPixel'

/**
 * Dispara PageView en navegación SPA solo en rutas públicas.
 */
export default function MetaPixelPageView() {
  const location = useLocation()

  useEffect(() => {
    if (isPublicMarketingPath(location.pathname)) {
      trackMetaPageView()
      trackWebVisit(location.pathname, location.search)
    }
  }, [location.pathname, location.search])

  return null
}
